module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "tp"
  }, [_vm._v("LEAVING THE"), _c('br'), _c('br'), _vm._v("ENCHANTED FOREST")]), _vm._v(" "), _c('p', {
    staticClass: "tp1"
  }, [_c('em', [_vm._v("The Path from Relationship Addiction"), _c('br'), _vm._v("to Intimacy")])]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_c('em', [_vm._v("Stephanie Covington"), _c('br'), _c('br'), _vm._v("and"), _c('br'), _c('br'), _vm._v("Liana Beckett")]), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780062043740_L01.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e26077","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062043740_epub_tp_r1.vue
// module id = 60
// module chunks = 0